import { YodaColors } from '../../yodaTheme';

export const toggleButtonGroupStyle = {
  height: '100%',
  backgroundColor: YodaColors.gray1,
  borderRadius: '30px',
  p: 0.5,
};

export const toggleButtonStyle = {
  textTransform: 'none',
  border: 'none',
  borderRadius: '30px !important',
  padding: '8px 24px',
  transition: 'all 0.3s ease',
  margin: '4px',

  '&.Mui-selected': {
    backgroundColor: YodaColors.white,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },

  '&:not(.Mui-selected):hover': {
    backgroundColor: 'transparent',
  },
};
